import React, { useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import cityTimezones from "city-timezones";
import { DateTime } from "luxon";
import Fuse from "fuse.js"; 

export default function CityTimeZoneSelector({ onChange, value }) {
  const [options, setOptions] = useState([]);

  const handleInputChange = (event, value) => {
    if (!value || value.length < 2) {
      setOptions([]);
      return;
    }

    const results = cityTimezones.lookupViaCity(value.trim());
    const uniqueZones = Array.from(
      new Map(results.map((r) => [r.timezone, r])).values()
    );

    const formatted = uniqueZones.map((match) => {
      const dt = DateTime.now().setZone(match.timezone);
      return {
        label: `${match.city}, ${match.region}, ${match.country} — ${dt.offsetNameShort} (UTC${dt.toFormat("ZZ")})`,
        value: match.timezone,
      };
    });

    setOptions(formatted);
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.label}
      onInputChange={handleInputChange}
      onChange={(e, newValue) => {
        if (newValue) {
          onChange(newValue.value);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Type a city name (e.g. San Diego)"
          inputProps={{
            ...params.inputProps,
            style: { height: "15px", padding: "0px" },
          }}
          style={{ width: "300px", marginLeft: "0px" }}
          InputLabelProps={{ style: { color: "white" } }}
        />
      )}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#1a039e",
            borderWidth: "1.5px",
          },
          "&:hover fieldset": {
            borderColor: "#d4d4d4",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#d4d4d4",
          },
        },
        "& input": {
          color: "white",
        },
      }}
    />
  );
}
